import { StatusGroupIds } from './../../modules/shared/constants/category-groupid.constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { AccountUserService } from 'src/app/service/account.service';
import { Observable } from 'rxjs';
import { TaskDefaultValues } from 'src/app/profile/tasks/models/taskDefaultValues.model';

@Injectable({
  providedIn: 'root'
})
export class SharedTaskService {

  appUrl = "";
  apiUrl = ""
  activity = "";
  apiUrlLogin="";
  activityUrl = "";
  user: any;
  constructor(private http: HttpClient, private accountUserService: AccountUserService) {
    this.accountUserService.user.subscribe(x => this.user = x);
    this.appUrl = environment.localApiUrl;
    this.apiUrl = environment.apiUrl;
    this.activity = environment.activity;
    this.apiUrlLogin = environment.apiUrlLogin;
    this.activityUrl = environment.activity + '/LionO360/2.0/API/';
  }



  getUsers(organizationId: number) {
    return this.http.get<any>(environment.appOrgUrl + `User?organizationId=${organizationId}`)
      .toPromise()
      .then(res => res);
  }

  getReminderTypes() {
    return this.http.get<any>(this.appUrl + "reminderTypes")
      .toPromise()
      .then(res => res);
  }

  getReminderDelays() {
    return this.http.get<any>(this.appUrl + "reminderDelays")
      .toPromise()
      .then(res => res);
  }

  getOccurrences() {
    return this.http.get<any>(this.apiUrl + "Occurence/GetAllOccurence")
      .toPromise()
      .then(res => res);
  }

  getPriorities() {
    return this.http.get<any>(this.appUrl + "priority")
      .toPromise()
      .then(res => res);
  }

  getTaskStatuses() {
    return this.http.get<any>(this.activityUrl + "Status?groupId=" + StatusGroupIds.TaskStatusGroupId)
      .toPromise()
      .then(res => res);
  }

  getTaskStatus(statusId) {
    return this.http.get<any>(this.apiUrl + "Status/" + statusId)
      .toPromise()
      .then(res => res);
  }

  addActivityTask(task) {
    return this.http.post(this.apiUrl + "ObjectTask", task)
      .toPromise()
      .then(res => res);
  }

  updateActivityTask(task) {
    return this.http.put(this.activityUrl + "Task/Status", task)
      .toPromise()
      .then(res => res);
  }

  //#region Implementation of (Re-write)and new functionality of Create Task 
  newAddTask(task): Observable<any>{
    return this.http.post<any>(`${this.activityUrl}TaskObject`, task)
  }

  getTaskDetailById(taskId): Observable<any>{
    return this.http.get<any>(`${this.activityUrl}ObjectTask/IsEdit?taskId=${taskId}`)
  }

  updateTask(taskData:any): Observable<any>{
    return this.http.put<any>(`${this.activityUrl}ObjectTask/Task`,taskData)
  }

  
  getTaskFeilds(): Observable<any>{
    return this.http.get<any>(`${this.activityUrl}Task/GetTemplatePermission`);
  }

  getTaskModules(){
    return this.http.get<any>(`${environment.activity}/LionO360/2.0/API/Filters/Module`)
  }

  getTaskDefaultValues(){
    return this.http.get<any>(`${environment.activity}/LionO360/2.0/API/TaskDefaultValue`)
  }

  setTaskDefaultValues(data:TaskDefaultValues){
    return this.http.post<any>(`${environment.activity}/LionO360/2.0/API/TaskDefaultValue`,data);
  }

  resetTaskDefaultValues(){
    return this.http.delete<any>(`${environment.activity}/LionO360/2.0/API/TaskDefaultValue`)
  }

  getNotificationEmailSettings(){
    return this.http.get<any>(`${environment.activity}/LionO360/2.0/API/ObjectTask/NotifyStatus`)
  }

  setNotificationEmailSettings(data:any){
    return this.http.post<any>(`${environment.activity}/LionO360/2.0/API/ObjectTask/NotifyStatus`,data)
  }

  deleteNotificationEmailSettings(data:any){
    return this.http.delete<any>(`${environment.activity}/LionO360/2.0/API/ObjectTask/NotifyStatus/${data}`)
  }

  deleteNotificationEmailFromTaskDetails(data:any){
    return this.http.delete<any>(`${environment.activity}/LionO360/2.0/API/ObjectTask/NotifyStatus/${data}`)
  }

  sendReminderToAssignee(data:any){
    return this.http.post<any>(`${environment.activity}/LionO360/2.0/API/Task/SendTaskReminder`,data)
  }

  allTaskPriorityList(){
    return this.http.get<any>(`${environment.activity}/LionO360/2.0/API/TaskPriority`)
  }

  addNewTaskPriority(data: any){
    return this.http.post<any>(`${environment.activity}/LionO360/2.0/API/TaskPriority`,data)
  }

  updateTaskPriority(data: any){
    return this.http.put<any>(`${environment.activity}/LionO360/2.0/API/TaskPriority`,data)
  }

  deleteTaskPriority(id: number){
    return this.http.delete<any>(`${environment.activity}/LionO360/2.0/API/TaskPriority/${id}`)
  }

  getTaskActiveCategoryGet(){
    return this.http.get(`${environment.activity}/LionO360/2.0/API/TaskCategory/ActiveCategory`);
}

  getTaskType(){
    return this.http.get<any>(`${environment.activity}/LionO360/2.0/API/Filters/TaskType`)
  }

  getTaskIds(data:any){
    return this.http.post<any>(`${environment.activity}/LionO360/2.0/API/Filters/TaskId`,data);
  }

}
